var _defs, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack361({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,7.51a4.42,4.42,0,0,0-4.42,4.42h8.85A4.42,4.42,0,0,0,8,7.51Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.59,
    y1: 4.08,
    x2: 7.06,
    y2: 6.73
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.99,
    y1: 5.04,
    x2: 5.33,
    y2: 7.37
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.87,
    y1: 6.83,
    x2: 3.93,
    y2: 8.56
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.5,
    y1: 9.24,
    x2: 3.02,
    y2: 10.16
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.5,
    y1: 9.17,
    x2: 12.98,
    y2: 10.09
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.1,
    y1: 6.77,
    x2: 12.04,
    y2: 8.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.97,
    y1: 5,
    x2: 10.63,
    y2: 7.33
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.36,
    y1: 4.07,
    x2: 8.89,
    y2: 6.71
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack361);
export default __webpack_public_path__ + "static/media/Symbol_pack_361.0659ce7d76a4bf14397035eea048fe76.svg";
export { ForwardRef as ReactComponent };